/// Auto-generated with ScanbotSDKCodegenV3. Modifications will be overwritten.
/// Generated from rtu-ui-v2/schemas/check/CheckScannerScreenTextLocalization.yaml
/**
Configuration of the all strings for check scanner screen.
*/
export class CheckScannerScreenTextLocalization {
    /** @param source {@displayType `DeepPartial<CheckScannerScreenTextLocalization>`} */
    constructor(source = {}) {
        /**
          Title for the top bar.
          
          Default is "Check Scanner"
          */
        this.topBarTitle = 'Check Scanner';
        /**
          Cancel button text for the top bar.
          
          Default is "Cancel"
          */
        this.topBarCancelButton = 'Cancel';
        /**
          Text for the top user guidance caption.
          
          Default is "Point the camera at the check"
          */
        this.topUserGuidance = 'Point the camera at the check';
        /**
          Text for the user guidance caption below the finder view.
          
          Default is "Looking for check..."
          */
        this.finderViewUserGuidance = 'Looking for check...';
        /**
          Title for the introduction screen.
          
          Default is "How to scan a check"
          */
        this.introScreenTitle = 'How to scan a check';
        /**
          Start scanning button text for the introduction screen.
          
          Default is "Start Scanning"
          */
        this.introScreenDoneButton = 'Start Scanning';
        /**
          The text explanation of the introduction screen.
          
          Default is "This scanner reads the MICR (Magnetic Ink Character Recognition) line – the numbers and characters printed at the bottom of your check.\n\nTo scan, place the check on a flat, well-lit surface and position your camera so the entire check is within the frame. The check data will be automatically extracted.\nTap 'Start Scanning' to begin."
          */
        this.introScreenText = "This scanner reads the MICR (Magnetic Ink Character Recognition) line – the numbers and characters printed at the bottom of your check.\n\nTo scan, place the check on a flat, well-lit surface and position your camera so the entire check is within the frame. The check data will be automatically extracted.\nTap 'Start Scanning' to begin.";
        /**
          Caption for the success overlay.
          
          Default is "Scanned successfully"
          */
        this.completionOverlaySuccessMessage = 'Scanned successfully';
        /**
          Accessibility description for the 'open introduction screen' button in top bar.
          
          Default is "Open Check Scanner introduction"
          */
        this.accessibilityDescriptionOpenIntroScreenButton = 'Open Check Scanner introduction';
        /**
          Accessibility description for the 'done'/'start scanning' button in the introduction screen.
          
          Default is "Start check scanning"
          */
        this.accessibilityDescriptionIntroScreenDoneButton = 'Start check scanning';
        /**
          Accessibility description for the 'cancel' button in the top bar.
          
          Default is "Cancel check scanning"
          */
        this.accessibilityDescriptionCancelButton = 'Cancel check scanning';
        /**
          Accessibility description for the 'retry' button in the alerts.
          
          Default is "Retry check scanning"
          */
        this.accessibilityDescriptionRetryButton = 'Retry check scanning';
        /**
          Accessibility description for the 'close scanner' button in the alerts.
          
          Default is "Close check scanner"
          */
        this.accessibilityDescriptionCloseScannerButton = 'Close check scanner';
        /**
          Try again button text for the alert.
          
          Default is "Retry"
          */
        this.checkAlertRetryButton = 'Retry';
        /**
          Close button text for the alert.
          
          Default is "Close Scanner"
          */
        this.checkAlertCloseScannerButton = 'Close Scanner';
        /**
          Title for the alert when Check is not detected.
          
          Default is "No check detected"
          */
        this.checkNoCheckDetectedAlertTitle = 'No check detected';
        /**
          Subtitle for the alert when Check is not detected.
          
          Default is "The scanner couldn't detect the check. Please ensure the check is valid, well-lit, and fully visible, then try again."
          */
        this.checkNoCheckDetectedAlertSubtitle = "The scanner couldn't detect the check. Please ensure the check is valid, well-lit, and fully visible, then try again.";
        /**
          Title for the alert when the image is not good.
          
          Default is "Check not recognized"
          */
        this.checkImageNotGoodAlertTitle = 'Check not recognized';
        /**
          Subtitle for the alert when the image is not good.
          
          Default is "Make sure the check is valid, well-lit, and fully visible. Then try again."
          */
        this.checkImageNotGoodAlertSubtitle = 'Make sure the check is valid, well-lit, and fully visible. Then try again.';
        /**
          Accessibility description for the flash button.
          
          Default is "Toggle flash"
          */
        this.accessibilityDescriptionFlashButton = 'Toggle flash';
        /**
          Accessibility value for the flash on button.
          
          Default is "On"
          */
        this.accessibilityStateFlashOnButton = 'On';
        /**
          Accessibility value for the flash off button.
          
          Default is "Off"
          */
        this.accessibilityStateFlashOffButton = 'Off';
        /**
          Accessibility description for the zoom button.
          
          Default is "Toggle camera zoom"
          */
        this.accessibilityDescriptionZoomButton = 'Toggle camera zoom';
        /**
          Accessibility description for the flip camera button.
          
          Default is "Flip camera"
          */
        this.accessibilityDescriptionFlipCameraButton = 'Flip camera';
        /**
          Accessibility value for the flip camera back button.
          
          Default is "Back"
          */
        this.accessibilityStateFlipCameraBackButton = 'Back';
        /**
          Accessibility value for the flip camera front button.
          
          Default is "Front"
          */
        this.accessibilityStateFlipCameraFrontButton = 'Front';
        /**
          The title of the camera permission dialog.
          
          Default is "Camera permission denied!"
          */
        this.cameraPermissionEnableCameraTitle = 'Camera permission denied!';
        /**
          The explanation text of the camera permission dialog.
          
          Default is "Please allow the usage of the camera to start the scanning process."
          */
        this.cameraPermissionEnableCameraExplanation = 'Please allow the usage of the camera to start the scanning process.';
        /**
          The 'enable' button title of the camera permission dialog.
          
          Default is "Grant permission"
          */
        this.cameraPermissionEnableCameraButton = 'Grant permission';
        /**
          The 'close' button title of the camera permission dialog.
          
          Default is "Close"
          */
        this.cameraPermissionCloseButton = 'Close';
        /**
          The accessibility hint for the 'enable' button of the camera permission dialog.
          
          Default is "Tap to grant camera permission"
          */
        this.accessibilityDescriptionCameraPermissionEnableCameraButton = 'Tap to grant camera permission';
        /**
          The accessibility hint for the 'close' button of the camera permission dialog.
          
          Default is "Close screen without granting permission"
          */
        this.accessibilityDescriptionCameraPermissionCloseButton = 'Close screen without granting permission';
        /**
          The user guidance text displayed when no check is found.
          
          Default is "Looking for check..."
          */
        this.checkUserGuidanceNoCheckFound = 'Looking for check...';
        /**
          The user guidance text displayed when a check presence was detected.
          
          Default is "Scanning the check..."
          */
        this.checkUserGuidanceScanningProgress = 'Scanning the check...';
        /**
          The user guidance text displayed when it is too dark to capture an adequate image.
          
          Default is "Too dark. Please turn on a light."
          */
        this.checkUserGuidanceTooDark = 'Too dark. Please turn on a light.';
        /**
          The user guidance text displayed when the detected check is too far away and appears too small.
          
          Default is "Please move closer to the check."
          */
        this.checkUserGuidanceTooSmall = 'Please move closer to the check.';
        /**
          The user guidance text displayed when the detected check is not in a good perspective (device tilted).
          
          Default is "Please hold your device straight over the check."
          */
        this.checkUserGuidanceBadPerspective = 'Please hold your device straight over the check.';
        if (source.topBarTitle !== undefined) {
            this.topBarTitle = source.topBarTitle;
        }
        if (source.topBarCancelButton !== undefined) {
            this.topBarCancelButton = source.topBarCancelButton;
        }
        if (source.topUserGuidance !== undefined) {
            this.topUserGuidance = source.topUserGuidance;
        }
        if (source.finderViewUserGuidance !== undefined) {
            this.finderViewUserGuidance = source.finderViewUserGuidance;
        }
        if (source.introScreenTitle !== undefined) {
            this.introScreenTitle = source.introScreenTitle;
        }
        if (source.introScreenDoneButton !== undefined) {
            this.introScreenDoneButton = source.introScreenDoneButton;
        }
        if (source.introScreenText !== undefined) {
            this.introScreenText = source.introScreenText;
        }
        if (source.completionOverlaySuccessMessage !== undefined) {
            this.completionOverlaySuccessMessage = source.completionOverlaySuccessMessage;
        }
        if (source.accessibilityDescriptionOpenIntroScreenButton !== undefined) {
            this.accessibilityDescriptionOpenIntroScreenButton = source.accessibilityDescriptionOpenIntroScreenButton;
        }
        if (source.accessibilityDescriptionIntroScreenDoneButton !== undefined) {
            this.accessibilityDescriptionIntroScreenDoneButton = source.accessibilityDescriptionIntroScreenDoneButton;
        }
        if (source.accessibilityDescriptionCancelButton !== undefined) {
            this.accessibilityDescriptionCancelButton = source.accessibilityDescriptionCancelButton;
        }
        if (source.accessibilityDescriptionRetryButton !== undefined) {
            this.accessibilityDescriptionRetryButton = source.accessibilityDescriptionRetryButton;
        }
        if (source.accessibilityDescriptionCloseScannerButton !== undefined) {
            this.accessibilityDescriptionCloseScannerButton = source.accessibilityDescriptionCloseScannerButton;
        }
        if (source.checkAlertRetryButton !== undefined) {
            this.checkAlertRetryButton = source.checkAlertRetryButton;
        }
        if (source.checkAlertCloseScannerButton !== undefined) {
            this.checkAlertCloseScannerButton = source.checkAlertCloseScannerButton;
        }
        if (source.checkNoCheckDetectedAlertTitle !== undefined) {
            this.checkNoCheckDetectedAlertTitle = source.checkNoCheckDetectedAlertTitle;
        }
        if (source.checkNoCheckDetectedAlertSubtitle !== undefined) {
            this.checkNoCheckDetectedAlertSubtitle = source.checkNoCheckDetectedAlertSubtitle;
        }
        if (source.checkImageNotGoodAlertTitle !== undefined) {
            this.checkImageNotGoodAlertTitle = source.checkImageNotGoodAlertTitle;
        }
        if (source.checkImageNotGoodAlertSubtitle !== undefined) {
            this.checkImageNotGoodAlertSubtitle = source.checkImageNotGoodAlertSubtitle;
        }
        if (source.accessibilityDescriptionFlashButton !== undefined) {
            this.accessibilityDescriptionFlashButton = source.accessibilityDescriptionFlashButton;
        }
        if (source.accessibilityStateFlashOnButton !== undefined) {
            this.accessibilityStateFlashOnButton = source.accessibilityStateFlashOnButton;
        }
        if (source.accessibilityStateFlashOffButton !== undefined) {
            this.accessibilityStateFlashOffButton = source.accessibilityStateFlashOffButton;
        }
        if (source.accessibilityDescriptionZoomButton !== undefined) {
            this.accessibilityDescriptionZoomButton = source.accessibilityDescriptionZoomButton;
        }
        if (source.accessibilityDescriptionFlipCameraButton !== undefined) {
            this.accessibilityDescriptionFlipCameraButton = source.accessibilityDescriptionFlipCameraButton;
        }
        if (source.accessibilityStateFlipCameraBackButton !== undefined) {
            this.accessibilityStateFlipCameraBackButton = source.accessibilityStateFlipCameraBackButton;
        }
        if (source.accessibilityStateFlipCameraFrontButton !== undefined) {
            this.accessibilityStateFlipCameraFrontButton = source.accessibilityStateFlipCameraFrontButton;
        }
        if (source.cameraPermissionEnableCameraTitle !== undefined) {
            this.cameraPermissionEnableCameraTitle = source.cameraPermissionEnableCameraTitle;
        }
        if (source.cameraPermissionEnableCameraExplanation !== undefined) {
            this.cameraPermissionEnableCameraExplanation = source.cameraPermissionEnableCameraExplanation;
        }
        if (source.cameraPermissionEnableCameraButton !== undefined) {
            this.cameraPermissionEnableCameraButton = source.cameraPermissionEnableCameraButton;
        }
        if (source.cameraPermissionCloseButton !== undefined) {
            this.cameraPermissionCloseButton = source.cameraPermissionCloseButton;
        }
        if (source.accessibilityDescriptionCameraPermissionEnableCameraButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionEnableCameraButton =
                source.accessibilityDescriptionCameraPermissionEnableCameraButton;
        }
        if (source.accessibilityDescriptionCameraPermissionCloseButton !== undefined) {
            this.accessibilityDescriptionCameraPermissionCloseButton =
                source.accessibilityDescriptionCameraPermissionCloseButton;
        }
        if (source.checkUserGuidanceNoCheckFound !== undefined) {
            this.checkUserGuidanceNoCheckFound = source.checkUserGuidanceNoCheckFound;
        }
        if (source.checkUserGuidanceScanningProgress !== undefined) {
            this.checkUserGuidanceScanningProgress = source.checkUserGuidanceScanningProgress;
        }
        if (source.checkUserGuidanceTooDark !== undefined) {
            this.checkUserGuidanceTooDark = source.checkUserGuidanceTooDark;
        }
        if (source.checkUserGuidanceTooSmall !== undefined) {
            this.checkUserGuidanceTooSmall = source.checkUserGuidanceTooSmall;
        }
        if (source.checkUserGuidanceBadPerspective !== undefined) {
            this.checkUserGuidanceBadPerspective = source.checkUserGuidanceBadPerspective;
        }
    }
}
//# sourceMappingURL=CheckScannerScreenTextLocalization.js.map